import React from "react";
import ReactDOMClient from "react-dom/client";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";
import { RootProps } from "./root.component";

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  },
});

export const { bootstrap, mount, unmount, update } = lifecycles;

export const options = `
  type Props {
    model: Model

    getData(ids: [ID]): [Any]
    createData(item: AnyInput): Any
    updateData(item: AnyInput): Any
    deleteData(item: AnyInput): Any

    onSelectRow(row: Any): Void
  }

  type Model {
    name: String
    input: String
  }
`;
